import { DataTableTypes } from '../../DataTableTypes';

const BASE = 'bp-dataTable';
const COLUMNS_CONFIGURATION = `${BASE}-columns-configuration`;
const FILTERS = `${BASE}-filters`;
const TABLE = `${BASE}-table`;
const ROW = `${TABLE}-row`;
const CELL = `${TABLE}-cell`;

export const dataTableClassnames = {
  root: BASE,
  variant: (variant: DataTableTypes.TableVariant) => variant,
  slots: {
    top: `${BASE}-slot-top`,
    bottom: `${BASE}-slot-bottom`,
    children: `${BASE}-slot-children`
  },
  header: {
    root: `${BASE}-header`,
    searchInput: `${BASE}-header-search-input`
  },
  footer: {
    root: `${BASE}-footer`
  },
  table: {
    root: TABLE,
    state: {
      empty: 'empty',
      loading: 'loading'
    },
    noResults: {
      root: `${BASE}-no-results`
    },
    body: `${TABLE}-tbody`,
    head: `${TABLE}-thead`,
    row: {
      root: ROW,
      head: `${ROW}-head`,
      body: `${ROW}-body`,
      actions: `${ROW}-actions`,
      sort: (type: string) => `${ROW}-sort-by-${type}`,
      sortState: (type: string) => `${ROW}-sort-by-${type}`,
      depth: (depth: number) => `${ROW}-depth-${depth}`,
      state: {
        selected: 'row-selected'
      }
    },
    cell: {
      root: CELL,
      content: `${CELL}-content`,
      head: `${CELL}-head`,
      body: `${CELL}-body`,
      resizer: {
        root: `${CELL}-resizer`,
        state: {
          resizing: 'is-resizing'
        }
      },
      menu: `${CELL}-field-menu`,
      selectRow: `${CELL}-field-select-row`,
      field: (id: string) => `${CELL}-field-${id}`
    }
  },
  columnsConfiguration: {
    root: COLUMNS_CONFIGURATION
  },
  filters: {
    root: FILTERS,
    filter: (id: string) => `${FILTERS}-filter-${id}`,
    filterWrapper: (id: string) => `${FILTERS}-filter-${id}-wrapper`
  }
} as const;
